import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader, Card } from '@/components/Primitives';
import { Field } from './Extensions';
import { FloppyDisk } from '@phosphor-icons/react';
import { useToast } from '@/hooks/use-toast';

const TollFraud = () => {
    const [s, setS] = useState(null);
    const { toast } = useToast();

    useEffect(() => {
        api.get('/toll-fraud').then((r) => setS(r.data));
    }, []);

    const save = async (e) => {
        e.preventDefault();
        try {
            await api.put('/toll-fraud', s);
            toast({ title: 'Uloženo' });
        } catch (err) {
            toast({ title: 'Chyba', description: err.response?.data?.detail || 'error', variant: 'destructive' });
        }
    };

    if (!s) return <div>Načítání…</div>;

    return (
        <>
            <PageHeader
                eyebrow="Security"
                title="Ochrana proti zneužití (Toll Fraud)"
                description="Limity, whitelist zemí a blokace prémiových čísel — zabraňte zneužití SIP účtů a vysokým telekomunikačním ztrátám."
            />
            <form onSubmit={save} className="space-y-4">
                <Card title="Denní limity">
                    <div className="grid grid-cols-2 gap-3">
                        <Field label="Denní limit minut (odchozí)" value={s.daily_outbound_minutes_limit}
                               onChange={(v) => setS({ ...s, daily_outbound_minutes_limit: parseInt(v || '0', 10) })}
                               mono type="number" />
                        <Field label="Denní limit hovorů" value={s.daily_outbound_calls_limit}
                               onChange={(v) => setS({ ...s, daily_outbound_calls_limit: parseInt(v || '0', 10) })}
                               mono type="number" />
                        <Field label="Limit minut na klapku" value={s.per_extension_outbound_minutes_limit}
                               onChange={(v) => setS({ ...s, per_extension_outbound_minutes_limit: parseInt(v || '0', 10) })}
                               mono type="number" />
                        <Field label="Rate limit (hovorů/min)" value={s.rate_limit_calls_per_minute}
                               onChange={(v) => setS({ ...s, rate_limit_calls_per_minute: parseInt(v || '0', 10) })}
                               mono type="number" />
                    </div>
                </Card>

                <Card title="Whitelist zemí (ISO kódy, oddělit čárkou)">
                    <input value={(s.country_whitelist || []).join(',')}
                           onChange={(e) => setS({ ...s, country_whitelist: e.target.value.split(',').map((x) => x.trim().toUpperCase()).filter(Boolean) })}
                           className="w-full px-3 py-2 bg-[var(--bg-app)] border text-sm font-mono"
                           style={{ borderColor: 'var(--border-default)', borderRadius: 2 }} />
                </Card>

                <Card title="Prémiové prefixy">
                    <input value={(s.blocked_prefixes || []).join(',')}
                           onChange={(e) => setS({ ...s, blocked_prefixes: e.target.value.split(',').map((x) => x.trim()).filter(Boolean) })}
                           className="w-full px-3 py-2 bg-[var(--bg-app)] border text-sm font-mono"
                           style={{ borderColor: 'var(--border-default)', borderRadius: 2 }} />
                    <label className="mt-3 inline-flex items-center gap-2 text-sm">
                        <input type="checkbox" checked={!!s.block_premium_numbers}
                               onChange={(e) => setS({ ...s, block_premium_numbers: e.target.checked })} />
                        Blokovat prémiová čísla
                    </label>
                </Card>

                <button type="submit"
                        className="inline-flex items-center gap-2 px-4 py-2 text-xs font-bold uppercase tracking-[0.08em]"
                        style={{ background: 'var(--brand)', color: '#fff', borderRadius: 2 }}>
                    <FloppyDisk size={14} weight="bold" />Uložit
                </button>
            </form>
        </>
    );
};

export default TollFraud;
